export default [
  {
    path: '/admin/role',
    name: 'admin_role',
    component: () => import('./RoleAdmin.vue'),
    meta: {
      name: 'Admin - Cargos',
    },
  },
]
